import Dialog from "@mui/material/Dialog";
import {
  FileForm,
  FileShareMode,
  Filev2,
  QueryProgress,
  RadioOption,
} from "core/types";
import { SetAction } from "ds_legacy/components/Tables/GeneralTable/MenuActions";
import { FileFeatureData } from "dsl/ecosystems/PatientFiles/useFilesFeature";
import { useDialogStyles } from "..";
import { ShareFile } from "./ShareFile";

export type FileShareModalProps = {
  file: Filev2 | FileForm | undefined;
  handleShareFile: (file: FileShareResultWithInitialValues) => Promise<void>;
  isOpen?: boolean;
  mutationProgress: QueryProgress;
  reset: () => void;
  setAction: SetAction<FileFeatureData>;
};

export type FileShareInitialValues = {
  selected_receivers: RadioOption[] | undefined;
  share_mode: FileShareMode;
};

export type FileShareValidationResult = {
  selected_receivers?: { value: RadioOption[] };
  share_mode: FileShareMode;
};
export type FileShareResult = {
  selected_receivers?: RadioOption[];
  share_mode: FileShareMode;
};

export type FileShareResultWithInitialValues = {
  selected_receivers?: RadioOption[];
  share_mode: FileShareMode;
} & { initialValues: FileShareInitialValues };

export function FileShareModal({
  file,
  handleShareFile,
  isOpen,
  mutationProgress,
  reset,
  setAction,
}: FileShareModalProps) {
  const classes = useDialogStyles();

  if (!isOpen) return null;

  return (
    <Dialog
      classes={{ paper: classes.dialog }}
      fullWidth
      maxWidth="sm"
      open={Boolean(isOpen)}
    >
      <ShareFile
        closeModal={reset}
        file={file}
        handleShareFile={handleShareFile}
        mutationProgress={mutationProgress}
        setAction={setAction}
      />
    </Dialog>
  );
}

export default FileShareModal;
